module.exports = __webpack_public_path__ + "img/wlt_main_mobile.5140852.webp";